import { LogLevels } from '@powersync/common';
import { AbstractStreamingSyncImplementation, LockType } from '@powersync/shared-internals';
import { getNavigatorLocks } from '../../shared/navigator.js';
export class WebStreamingSyncImplementation extends AbstractStreamingSyncImplementation {
    constructor(options) {
        // Super will store and provide default values for options
        super(options);
    }
    get webOptions() {
        return this.options;
    }
    async obtainLock(lockOptions) {
        const identifier = `streaming-sync-${lockOptions.type}-${this.webOptions.identifier}`;
        if (lockOptions.type == LockType.SYNC) {
            this.logger.log({ level: LogLevels.debug, message: `requesting lock for ${identifier}` });
        }
        return getNavigatorLocks().request(identifier, { signal: lockOptions.signal }, lockOptions.callback);
    }
}
//# sourceMappingURL=WebStreamingSyncImplementation.js.map